// Generated by scripts/prebuild.js
export const version = '17.2.1';
